// extracted by mini-css-extract-plugin
export default {"onsiteInfo":"InfoTooltip_onsiteInfo__RVS1B","onsiteInfoTooltiptext":"InfoTooltip_onsiteInfoTooltiptext__KTO69"};